<template>
  <div class="download-page">
    <h4 class="mb-3">下載你的時代肖像</h4>

    <img
      v-if="imgUrl && !imageExpired"
      :src="imgUrl"
      class="preview"
      alt="portrait"
      @error="handleImageError"
    />

    <div v-else class="expired-box">
      <div class="expired-title">圖片已過期或不存在</div>
      <div class="expired-text">
        此下載連結可能已失效，若活動已結束或圖片已下架，將無法再開啟。
      </div>
    </div>

    <div class="mt-3 d-flex justify-content-center gap-2">
      <button
        class="btn block-btn"
        :disabled="imageExpired || !imgUrl"
        @click="downloadFromUrl"
      >
        {{ imageExpired || !imgUrl ? '圖片已過期' : '下載圖片' }}
      </button>
    </div>

    <p class="tip" v-if="!imageExpired && imgUrl">
      <br>📱 iPhone：請長按圖片 →「儲存到照片」<br>
      🤖 Android：請長按圖片 →「下載圖片」
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    imgUrl() {
      return this.$route.query.img || ''
    }
  },
  data() {
    return {
      imageExpired: false,
    }
  },
  watch: {
    imgUrl: {
      immediate: true,
      handler(newVal) {
        this.imageExpired = !newVal
      }
    }
  },
  methods: {
    // async downloadFromUrl() {
    //   if (!this.imgUrl) return

    //   try {
    //     // 1) 把跨網域圖片抓回來變 blob
    //     const res = await fetch(this.imgUrl, { mode: 'cors' })
    //     if (!res.ok) throw new Error(`fetch failed: ${res.status}`)

    //     const blob = await res.blob()
    //     const objUrl = URL.createObjectURL(blob)

    //     // 2) 用 blob URL 觸發下載（同 origin 的 blob，download 幾乎會生效）
    //     const a = document.createElement('a')
    //     a.href = objUrl
    //     a.download = `Portrait_of_Time_${Date.now()}.png`
    //     document.body.appendChild(a)
    //     a.click()
    //     document.body.removeChild(a)

    //     URL.revokeObjectURL(objUrl)
    //   } catch (e) {
    //     console.error(e)
    //     // 下載失敗就退回「開圖讓使用者長按」
    //     window.open(this.imgUrl, '_blank')
    //   }
    // }
    handleImageError() {
      this.imageExpired = true
    },
    downloadFromUrl() {
      if (this.imageExpired || !this.imgUrl) {
        return
      }

      let pathname = this.imgUrl

      // 如果是完整 URL，轉成 pathname
      if (pathname.startsWith('http')) {
        pathname = new URL(pathname).pathname
      }

      // 只允許 /media/ 開頭（安全）
      if (!pathname.startsWith('/media/')) {
        console.error('Invalid media path:', pathname)
        return
      }

      // 取出 TP/2026/... 的相對路徑
      const rel = pathname.replace(/^\/media\//, '')

      // 用同域相對路徑，不用 origin
      const downloadUrl = `/stable_diffusion/download/tp?path=${encodeURIComponent(rel)}`

      window.location.href = downloadUrl
    }
  }
}
</script>

<style scoped>
.download-page {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px;
  text-align: center;
}

.preview {
  max-width: 100%;
  border-radius: 12px;
}

.expired-box {
  max-width: 100%;
  min-height: 320px;
  padding: 32px 24px;
  border-radius: 12px;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.expired-title {
  font-size: 22px;
  font-weight: 700;
  color: #495057;
}

.expired-text {
  margin-top: 12px;
  font-size: 15px;
  line-height: 1.7;
  color: #6c757d;
}

.tip {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.block-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
